/* NHD - Heart Attack Proof, EVERGREEN masterclass.
   Loaded only on page.heart-attack-proof-masterclass-evergreen.
   Every query is scoped to .nhd-hapev so nothing in the Prestige theme is touched. */
(function () {
  var root = document.querySelector('.nhd-hapev');
  if (!root) return;

  var YT = 'https://www.youtube-nocookie.com/embed/';
  var PARAMS = '?autoplay=1&rel=0&modestbranding=1&playsinline=1';

  function looksLikeId(v) {
    return !!v && /^[A-Za-z0-9_-]{11}$/.test(v);
  }

  function frame(id, title) {
    var f = document.createElement('iframe');
    f.src = YT + encodeURIComponent(id) + PARAMS;
    f.title = title || 'Natural Heart Doctor video';
    f.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    return f;
  }

  /* ---- Inline click-to-load facades (hero masterclass, free primer) ---- */
  var facades = root.querySelectorAll('.ytf');
  Array.prototype.forEach.call(facades, function (el) {
    var id = el.getAttribute('data-yt');
    if (!looksLikeId(id)) {
      /* Placeholder id still in place. Leave the poster up rather than
         loading a broken player, and do not trap the keyboard on it. */
      el.removeAttribute('role');
      el.removeAttribute('tabindex');
      el.style.cursor = 'default';
      return;
    }
    function activate() {
      if (el.classList.contains('ytf-loaded')) return;
      el.classList.add('ytf-loaded');
      el.innerHTML = '';
      el.appendChild(frame(id, el.getAttribute('aria-label')));
    }
    el.addEventListener('click', activate);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); activate(); }
    });
  });

  /* ---- Segment lightbox ---- */
  var box = root.querySelector('#nhdHapevLightbox');
  var frameHost = box ? box.querySelector('.ytlb-frame') : null;
  var capHost = box ? box.querySelector('.ytlb-cap') : null;
  var closeBtn = box ? box.querySelector('.ytlb-close') : null;
  var lastFocus = null;

  function closeBox() {
    if (!box || box.hidden) return;
    box.hidden = true;
    frameHost.innerHTML = '';
    capHost.innerHTML = '';
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openBox(id, title, trigger) {
    if (!box || !looksLikeId(id)) return;
    lastFocus = trigger || null;
    frameHost.innerHTML = '';
    frameHost.appendChild(frame(id, title));
    capHost.innerHTML = title || '';
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  var segs = root.querySelectorAll('[data-yt-lightbox]');
  Array.prototype.forEach.call(segs, function (btn) {
    var id = btn.getAttribute('data-yt-lightbox');
    if (!looksLikeId(id)) {
      /* Placeholder id. Disable rather than open an empty player. */
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.style.opacity = '.45';
      btn.style.cursor = 'not-allowed';
      return;
    }
    btn.addEventListener('click', function () {
      openBox(id, btn.getAttribute('data-yt-title'), btn);
    });
  });

  if (box) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-ytlb-close]'), function (el) {
      el.addEventListener('click', closeBox);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeBox();
    });
    /* Keep tab focus inside the dialog while it is open. */
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || box.hidden) return;
      e.preventDefault();
      if (closeBtn) closeBtn.focus();
    });
  }

  /* ---- Scroll reveal (single motion system, respects reduced motion) ---- */
  var els = root.querySelectorAll('.sec-head, .pcard, .stakes-grid > div, .duel, .door, .res-card, .step-card, .faq-item, .pull, .tl-node');
  Array.prototype.forEach.call(els, function (el, i) {
    el.classList.add('rv');
    el.style.transitionDelay = (i % 3) * 70 + 'ms';
  });
  if (!('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    Array.prototype.forEach.call(els, function (el) { el.classList.add('in'); });
  } else {
    var o = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); o.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(els, function (el) { o.observe(el); });
  }

  /* ---- ECG line draws once when scrolled into view ---- */
  var band = root.querySelector('.ecg-band');
  if (band) {
    if (!('IntersectionObserver' in window)) { band.classList.add('play'); }
    else {
      var o2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { band.classList.add('play'); o2.disconnect(); } });
      }, { threshold: 0.35 });
      o2.observe(band);
    }
  }

  /* ---- Smooth in-page anchors, scoped to links inside this page block ---- */
  var anchors = root.querySelectorAll('a[href^="#"]');
  Array.prototype.forEach.call(anchors, function (a) {
    a.addEventListener('click', function (e) {
      var id = this.getAttribute('href').slice(1);
      if (!id) return;
      var el = root.querySelector('#' + id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();